export default __webpack_public_path__ + "static/media/ding.120be770.wav";